import React, { useState, useEffect } from "react";

import {
  Modal,
  ModalBody,
  Button,
  Progress,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Popover,
  PopoverHeader,
  PopoverBody,
  Row,
  Col,
  InputGroup,
  Input,
  InputGroupAddon,
  Collapse,
  ModalHeader,
  Label,
  ModalFooter,
  UncontrolledDropdown,
  DropdownItem,
  Table,
  Card,
} from "reactstrap";

import TrivvyHolidayTemplates from "./TrivvyHolidayTemplates";
import TrivvyCustomTemplateForm from "./TrivvyCustomTemplateForm";
import axios from "../../../../axios";
import * as url from "../../../../utils/url";
import { TEMPLATE_TYPE_CSS_CLASS } from "../../data";

export default function TriviaTemplatesModalMain({
  open,
  onClose,
  addTrivvySuccessFromTemplates,
  onBack,
  uiType = "POPUP",
}) {
  const [selectedType, setSelectedType] = useState(null);
  const [customTemplates, setCustomTemplates] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    axios
      .get(url.getStandardCustomTemplates)
      .then(({ data }) => {
        setCustomTemplates(data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const modalUi = () => {
    return (
      <div>
        {selectedType != null ? (
          <div className="p-3">
            {selectedType == "HOLIDAY" ? (
              <TrivvyHolidayTemplates
                handleBack={() => setSelectedType(null)}
                addTrivvySuccessFromTemplates={addTrivvySuccessFromTemplates}
              />
            ) : (
              <TrivvyCustomTemplateForm
                selectedType={selectedType}
                handleBack={() => setSelectedType(null)}
                addTrivvySuccessFromTemplates={addTrivvySuccessFromTemplates}
                selectedId={selectedId}
              />
            )}
          </div>
        ) : (
          <div className="my-2">
            {customTemplates.length > 0 && (
              <div>
                <Row className="mt-1 mb-4">
                  <Col className="my-3" xs={6} md={6}>
                    <div
                      className="template-type-block holiday-block"
                      onClick={() => setSelectedType("HOLIDAY")}
                    >
                      Calendar Celebrations
                    </div>
                  </Col>

                  {customTemplates.map((template) => {
                    return (
                      <Col className="my-3" xs={6} md={6}>
                        <div
                          className={`template-type-block ${TEMPLATE_TYPE_CSS_CLASS[template.templateType]}`}
                          onClick={() => {
                            setSelectedId(template._id)
                            setSelectedType(template.templateType)
                          }}
                        >
                          {template.name}
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };
  return (
    <div>
      {uiType == "POPUP" ? (
        <Modal size="xl" isOpen={open}>
          <ModalHeader className="trivia_modal_header_bg" toggle={onClose}>
            Trivvy Templates
          </ModalHeader>
          <ModalBody className="trivia_modal_templates">{modalUi()}</ModalBody>
        </Modal>
      ) : (
        <div>
          {modalUi()}

          {!selectedType && (
            <ModalFooter className="justify-content-between">
              {onBack ? <Button onClick={onBack}>Back</Button> : ""}
            </ModalFooter>
          )}
        </div>
      )}
    </div>
  );
}
